import React, { useRef, useEffect } from "react";
import "./Styles/components.css";
import "./Styles/Navbar.css";
import { data } from "./MenuBarItems";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { Link } from "react-scroll";

const Navbar = ({ children, ...restProps }) => {
  const sliderRef = useRef(null);

  const handleScroll = () => {
    const slider = sliderRef.current;
    if (slider) {
      const activeAnchor = document.querySelector(".active");
      if (activeAnchor) {
        const sliderRect = slider.getBoundingClientRect();
        const anchorRect = activeAnchor.getBoundingClientRect();
        const sliderCenter = sliderRect.left + sliderRect.width / 2;
        const anchorCenter = anchorRect.left + anchorRect.width / 2;
        const scrollAmount = anchorCenter - sliderCenter;
        slider.scrollLeft += scrollAmount;
      }
    }
  };

  useEffect(() => {
    const debouncedHandleScroll = debounce(handleScroll, 100);
    window.addEventListener("scroll", debouncedHandleScroll);
    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
    };
  }, []);
  

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };
  

  const slideLeft = () => {
    const slider = sliderRef.current;
    if (slider) {
      const screenWidth = window.innerWidth;
      let scrollRatio;
  
      if (screenWidth < 600) {
        // Mobile screens
        scrollRatio = 0.84;
      } else if (screenWidth < 900) {
        // Tablet screens
        scrollRatio = 0.92;
      } else {
        // Desktop screens
        scrollRatio = 0.8;
      }
  
      const scrollAmount = -screenWidth * scrollRatio;
      const currentPosition = slider.scrollLeft;
      const newPosition = currentPosition + scrollAmount;
      smoothScrollTo(slider, newPosition, 300);
    }
  };
  
  const slideRight = () => {
    const slider = sliderRef.current;
    if (slider) {
      const screenWidth = window.innerWidth;
      let scrollRatio;
  
      if (screenWidth < 600) {
        // Mobile screens
        scrollRatio = 0.84;
      } else if (screenWidth < 900) {
        // Tablet screens
        scrollRatio = 0.92;
      } else {
        // Desktop screens
        scrollRatio = 0.8;
      }
  
      const scrollAmount = screenWidth * scrollRatio;
      const currentPosition = slider.scrollLeft;
      const newPosition = currentPosition + scrollAmount;
      smoothScrollTo(slider, newPosition, 300);
    }
  };
  
  
  
  const smoothScrollTo = (element, to, duration) => {
    const start = element.scrollLeft;
    const change = to - start;
    const increment = 20;
  
    let currentTime = 0;
  
    const animateScroll = () => {
      currentTime += increment;
      const val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollLeft = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
  
    animateScroll();
  };
  
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };
  
  return (
    <div {...restProps} className={`theme-div Navbar-div ${restProps.className}`}>
      <div className={`theme-div Navbar-div-0`}>
        <div className="sticky-top">
          <ul className={`theme-ul Navbar-ul`}>
            <MdChevronLeft className="leftarrow" onClick={slideLeft} size={40} />
            <div id="slider" className="Bar" ref={sliderRef}>
              {data.map((item, id) => (
                <Link
                  key={id}
                  className="anchor"
                  id={id}
                  activeClass="active"
                  to={item.link}
                  spy
                  smooth
                  offset={-50}
                  duration={500}
                  isDynamic={true}
                  onSetActive={handleScroll}
                  activeStyle={{ backgroundColor: "var(--secondary-color)" }}
                >
                  {item.name}
                </Link>
              ))}
            </div>
            <MdChevronRight className="rightarrow" onClick={slideRight} size={40} />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
